<template>
  <div>
    <WebHeaderView :title="$t('menu.withdraw')" />
    <div class="page-content">
      <van-tabs
        @click="tabClick"
        v-model="active"
        color="#fff"
        title-active-color="#fff"
      >
        
        <van-tab title="钱包" :name="2" />
        <van-tab title="IM钱包" :name="3" />
        <van-tab title="银行卡" :name="1" />
      </van-tabs>
      <div class="withdraw-type">
        <div v-if="active == 1">
          <div
            class="deposit-bq"
            :class="item.id == bank.id ? '' : 'noBorder'"
            v-for="(item, index) in banks"
            :key="index"
            @click="SelectBank(item)"
          >
            <div class="deposit-item active">
              <div class="deposit-info">
                <img :src="item.bank_img" alt="" class="icon" />
                <span>
                  {{ item.bank_name }}---{{ item.branch }}<br />
                  <span class="subText"> {{ item.card_number }}</span></span
                >
              </div>
            </div>
          </div>
          <div
            class="deposit-bq noBorder"
            @click="$router.push({ name: 'bank', query: { type: 1 } })"
          >
            <div class="deposit-item active">
              <div class="deposit-info">
                <van-icon name="plus" size="32" class="icon" />
                <span>
                  添加取款方式<br />
                  <span class="subText">添加银行卡</span></span
                >
              </div>
            </div>
          </div>
        </div>
        <div v-if="active == 2">
          <van-grid :border="false">
            <van-grid-item v-for="(item, index) in wallets" :key="index">
              <div
                style="width: 100%; position: relative; padding-bottom: 10px"
                :class="usrIndex == index ? 'selectd' : ''"
                @click="selectItem(item, index)"
              >
                <img
                  :src="item.logo"
                  style="width: 37px; height: 37px; margin: 8px auto"
                />
                <p>{{ item.name }}</p>
                <span style="color: red; font-size: 14px"
                  >{{ item.min_price }} ~ {{ item.max_price }}</span
                >
                <div class="select-icon" v-if="usrIndex == index">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 32 32"
                    class="h-5 w-5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 16.5L32 0V22C32 27.5228 27.5228 32 22 32H0L15 16.5Z"
                      fill="#cca352"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M26.2438 17.0091C26.4403 17.1401 26.5767 17.3438 26.623 17.5754C26.6693 17.807 26.6218 18.0475 26.4908 18.2441L20.5533 27.1503C20.4801 27.2598 20.3836 27.3518 20.2707 27.4195C20.1577 27.4873 20.0312 27.5292 19.9001 27.5421C19.769 27.555 19.6367 27.5388 19.5127 27.4944C19.3887 27.4501 19.276 27.3788 19.1829 27.2857L15.6204 23.7232C15.4631 23.5543 15.3774 23.331 15.3815 23.1003C15.3856 22.8696 15.479 22.6494 15.6422 22.4862C15.8054 22.3231 16.0255 22.2296 16.2563 22.2255C16.487 22.2215 16.7103 22.3071 16.8791 22.4644L19.6733 25.2586L25.0088 17.2549C25.14 17.0585 25.3438 16.9224 25.5754 16.8763C25.807 16.8302 26.0474 16.8779 26.2438 17.0091Z"
                      fill="white"
                    ></path>
                  </svg>
                </div>
              </div>
            </van-grid-item>
          </van-grid>
          <div style="font-size: 13px; color: red">
            {{ selectType.withdraw_desc }}
          </div>
        </div>
      </div>
      <div class="withdarw-inf" v-if="active == 2 && selectType && selectType.mode == 2">
        <div
          class="post-btn"
          style="width: 96% !important; margin: 20px auto"
          @click="openNativePage()"
        >
          联系客服
        </div>
      </div>
      <div class="withdarw-inf" v-else>
        <van-row>
          <van-col span="8">金额</van-col>
          <van-col span="16" style="text-align: right">
            <div v-if="active == 2">
              <span style="color: #cca352"
                >{{ selectType.min_price }}~{{ selectType.max_price }} 元</span
              >
            </div></van-col
          >
          <van-col span="24" style="margin: 10px 0">
            <van-field
              v-model="amount"
              type="number"
              placeholder="请输入取款金额"
            >
              <template #right-icon> CNY </template>
            </van-field>
          </van-col>
          <van-col span="12" v-if="active == 2"
            >参考汇率
            <span style="color: #cca352"
              >{{ selectType.rate }} = 1CNY</span
            ></van-col
          >
          <van-col span="12" style="text-align: right" v-if="active == 2"
            >预计到账
            <span style="color: #cca352"
              >{{ amount && amount.length > 0 ? amount / selectType.rate : 0 }}
              {{ selectType.name }}</span
            ></van-col
          >
        </van-row>
        <van-row style="margin-top: 15px">
          <van-col span="24">支付密码</van-col>
          <van-col span="24" style="margin: 10px 0">
            <van-field
              v-model="password"
              type="password"
              placeholder="请输入支付密码"
            >
            </van-field>
          </van-col>
        </van-row>
        <div
          class="post-btn"
          style="width: 96% !important; margin: 20px auto"
          @click="withdraw"
        >
          确定
        </div>
      </div>
      
    </div>
    <van-dialog
      v-model="showdialog"
      title="实名认证"
      show-cancel-button
      :showCancelButton="true"
      confirmButtonText="确认"
      cancelButtonText="返回"
      v-if="showdialog"
      @cancel="$router.back()"
      @confirm="onSubmit"
    >
      <van-form>
        <van-field
          v-model="username"
          label="真实姓名"
          placeholder="请填写真实姓名"
        />
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
export default {
  name: 'WithdrawView',
  components: {
    WebHeaderView
  },
  data () {
    return {
      amount: null,
      password: null,
      active: 2,
      withdrawtype: [],
      banks: [],
      bank: {},
      wallets: [],
      usrIndex: 0,
      selectType: {},
      showdialog: false,
      username: null
    }
  },
  mounted () {
    this.GetBank()
    // this.getusrInf()
  },
  methods: {
    checkDevice () {
      const u = navigator.userAgent
      return {
        isAndroid: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      }
    },
    isIOS () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    },
    openNativePage () {
      const device = this.checkDevice()
      if (device.isAndroid) {
        // this.callAndroidMethod('toKeFu', { page: 'toKeFu' })
        let targetUserId = '1'; 
        let apiObjectName = '_dsbridge';
        if (window[apiObjectName] && window[apiObjectName].toKefu) {
          window[apiObjectName].toKefu(targetUserId); 
        } else {
          this.$toast.fail('Android方法未注入')
        }

      } else if (this.isIOS()) {
        if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openBrowser){
          try {
            window.webkit.messageHandlers.openBrowser.postMessage('tokefu');
          } catch (error) {
            this.$toast.fail('IOS方法调用失败')
          }
        } else {
          this.$toast.fail('IOS方法未注入')
        }
        
        
        //this.callIOSMethod('toKeFu', { page: '' })
      } else {
        this.$router.push({ name: 'news'});
      }
    },
    async onSubmit () {
      if (!this.username) {
        this.$toast.fail('请填写真实姓名')
        setTimeout(() => {
          // location.reload()
          this.showdialog = true
        }, 1500)
        return
      }
      await this.$http({
        method: 'post',
        url: 'setName',
        data: {realname:this.username}
      }).then(data => {
       this.$toast.success(data)
       setTimeout(() => {
          location.reload()
        }, 1500)
      })
    },
    async getusrInf () {
      await this.$http({
        method: 'post',
        url: 'usrInf'
      }).then(data => {
        if (!(data.data.realname && data.data.realname.length > 0)) {
          this.showdialog = true
        }
      })
    },
    selectItem (item, index) {
      this.selectType = item
      this.usrIndex = index
    },
    SelectBank (item) {
      this.bank = item
    },
    tabClick (val) {
      this.active = val
    },
    async GetBank () {
      await this.$http({
        method: 'post',
        url: 'withdrawtype'
      }).then(data => {
        this.banks = data.data.filter(e => e.type == 1)[0].info
        this.wallets = data.data.filter(e => e.type == 2)
        this.selectItem(this.wallets[0], 0)
      })
    },
    async withdraw () {
      let that = this
      let bank = that.bank.id
      let amount = that.amount
      let password = that.password

      if (this.active == 1) {
        if (!bank) {
          that.$toast.fail('您要提现到那张银行卡？')
          return
        }
      }
      if (this.active == 2) {
        if (!this.selectType) {
          that.$toast.fail('请选择要提醒的钱包！')
          return
        } else {
          if (this.selectType.is_bind == 0) {
            that.$toast.fail('当前选择的钱包没有绑定地址！')
            this.$router.push({ name: 'bank' })
            return
          }
        }
      }
      if (amount < this.selectType.min_price) {
        that.$toast.fail('单笔取款不能低于' + this.selectType.min_price + '元')
        return
      }
      if (amount > this.selectType.max_price && this.active != 3) {
        that.$toast.fail('单笔取款不能高于' + this.selectType.max_price + '元')
        return
      }

      if (!password) {
        that.$toast.fail('请输入您的支付密码')
        return
      }

      let tmp = {
        amount: amount,
        password: password,
        type: this.active,
        bank: null,
        aisle_id: null
      }
      if (tmp.type == 1) {
        tmp.bank = bank
      } else if (tmp.type == 2) {
        tmp.bank = this.selectType.bank_id
        tmp.aisle_id = this.selectType.id
      }

      await this.$http({
        method: 'post',
        url: 'dowithdraw',
        data: tmp
      }).then(data => {
        that.$toast.success(data.msg)
        that.amount = null
        that.password = null
        that.bank = null
        setTimeout(() => {
          this.$router.push({ name: 'turnover', query: { type: 2 } })
        }, 1500)
      })
    }
  }
}
</script>
<style scoped>
.selectd {
  border: 1px solid #cca352 !important;
  color: #cca352 !important;
  border-radius: 10px;
}
.select-icon {
  position: absolute;
  right: 0px;
  bottom: -5px;
}
.withdarw-inf {
  width: 94%;
  margin: 20px auto;
  text-align: left;
  font-size: 14px;
  line-height: 1.4;
}
.deposit-bq {
  text-align: left;
  margin: 10px auto;
  width: 90%;
  height: 60px;
  background: #282828;
  border: 1px solid #cca352;
  border-radius: 5px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 15px;
  margin-bottom: 15px;
  position: relative;
}
.noBorder {
  border: 1px solid transparent;
}
.deposit-bq .deposit-info {
  font-size: 14px;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.deposit-bq .deposit-info .icon {
  width: 32px;
  height: 32px;
  margin-right: 20px;
  margin-left: 10px;
}
.deposit-bq .deposit-item .deposit-info .subText {
  font-size: 12px;
  color: #999;
  font-weight: 400;
}
</style>
<style>
.withdarw-inf .van-cell {
  background-color: #222 !important;
}
.withdarw-inf .van-field__control {
  color: #fff !important;
}
</style>
